var React = require('react');

function DuvetCover (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.4 5.6H22.7C23.9703 5.6 25 4.57026 25 3.3V3.3C25 2.02975 23.9703 1 22.7 1H21H5.6C3.05949 1 1 3.05949 1 5.6V5.6C1 8.14051 3.05949 10.2 5.6 10.2H21","stroke":"#0D1E2A","key":0}),React.createElement("path",{"d":"M19.8 5.6001L20.4 5.6001C22.9405 5.6001 25 7.65957 25 10.2001V10.2001C25 12.7406 22.9405 14.8 20.4 14.8L3.49998 14.8C2.22973 14.8 1.2 13.7703 1.2 12.5V12.5C1.2 11.2298 2.22974 10.2 3.49998 10.2L6.4 10.2","stroke":"#0D1E2A","key":1})]);
}

DuvetCover.defaultProps = {"width":"26","height":"16","viewBox":"0 0 26 16","fill":"none"};

module.exports = DuvetCover;

DuvetCover.default = DuvetCover;
